// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__HFM99","label":"Section_label__b0-Jh","contentWrap":"Section_contentWrap__nPAt9","footer":"Section_footer__3B3Fo","footerInner":"Section_footerInner__2RmE6"};